"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackScreenView = exports.logEvent = void 0;
const mixpanel_browser_1 = __importDefault(require("mixpanel-browser"));
const analyticsUtils_1 = require("./analyticsUtils");
const logEvent = (name, extraProperties = null) => analyticsUtils_1.logEventUtil(name, extraProperties, mixpanel_browser_1.default);
exports.logEvent = logEvent;
const trackScreenView = (previousRouteName, currentRouteName) => analyticsUtils_1.trackScreenViewUtil(previousRouteName, currentRouteName, mixpanel_browser_1.default);
exports.trackScreenView = trackScreenView;
